import { render } from "./FaqDetails.vue?vue&type=template&id=c44964f8&scoped=true"
import script from "./FaqDetails.vue?vue&type=script&lang=js"
export * from "./FaqDetails.vue?vue&type=script&lang=js"

import "./FaqDetails.vue?vue&type=style&index=0&id=c44964f8&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c44964f8"]])

export default __exports__